import { render } from "./Bajas.vue?vue&type=template&id=1f71366c&scoped=true"
import script from "./Bajas.vue?vue&type=script&lang=js"
export * from "./Bajas.vue?vue&type=script&lang=js"

import "./Bajas.vue?vue&type=style&index=0&id=1f71366c&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/gasoil/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f71366c"]])

export default __exports__